module.exports = __webpack_public_path__ + "static/media/img-2-1200x1000.ba449a06.jpg";